import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

const DefaultScales = {
  number: [
    { key: 'high', label: 'varCategories.high', intent: 'danger' },
    { key: 'medium', label: 'varCategories.medium', intent: 'warning' },
    { key: 'low', label: 'varCategories.low', intent: 'success' }
  ],
  time: [
    { key: 'long', label: 'leadTimeCategories.long', intent: 'danger' },
    { key: 'medium', label: 'leadTimeCategories.medium', intent: 'warning' },
    { key: 'short', label: 'leadTimeCategories.short', intent: 'success' }
  ],
  bufferCriticality: [
    { key: 'critical', label: 'critical', intent: 'critical' },
    { key: 'high', label: 'high', intent: 'danger' },
    { key: 'medium', label: 'medium', intent: 'warning' },
    { key: 'low', label: 'low', intent: 'success' },
    { key: 'otog', label: 'otog', intent: 'primary' }
  ]
};

const DEFAULT_UNIT = 'number';

export default class BvNotationScale extends Component {
  @tracked scale;

  constructor() {
    super(...arguments);
    this.scale = this.args.scale ?? DefaultScales[this.unit] ?? [];
  }

  get unit() {
    return this.args.unit || DEFAULT_UNIT;
  }

  get selectedItem() {
    let { value } = this.args;
    return value && this.scale.find((s) => s.key && s.key === value);
  }
}
